// extracted by mini-css-extract-plugin
export default {"awards":"styles_awards__sFOnp","container":"styles_container__k+XZ8","imgContainer":"styles_imgContainer__VlqUd"};